import React from 'react';
import { useTranslation } from 'react-i18next';

interface ToggleProps {
  isShow: boolean;
  toggle: () => void;
}

export const ToggleButton = ({ isShow, toggle }: ToggleProps) => {
  const { t } = useTranslation('', { keyPrefix: 'checkout.summary' });

  const cls = [
    'order-summary__toggle',
    isShow ? 'order-summary__toggle-show' : '',
  ].join(' ');

  const title = t(!isShow ? 'toggle.show' : 'toggle.hide');

  return (
    <div className={cls} onClick={toggle}>
      <span>{title}</span>
      <span className="order-summary__toggle-icon-wrap">
        <svg
          className="order-summary__toggle-icon"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 11L8 6L3 11"
            stroke="#115C36"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </svg>
      </span>
    </div>
  );
};
